<template>
  <div v-if="loading">Loading...</div>
  <div v-else-if="error">{{ error }}</div>
</template>

<script>
import { msalService } from "@/_services/msal.service";

export default {
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  created() {
    // If MSAL opened this page inside a popup (loginPopup/acquireTokenPopup),
    // the opener window is responsible for detecting the redirect back here
    // and closing the popup itself (via polling popupWindow.location, using
    // state stored in the opener's own sessionStorage — not available here).
    // Running our own redirect handling in that context can't succeed (no
    // matching state/nonce) and, if the opener fails to close the popup in
    // time (e.g. Cross-Origin-Opener-Policy blocking that), leaves the user
    // staring at a broken "Missing code or state" render of the full app
    // inside the popup. So just do nothing and let MSAL close the window.
    if (window.opener && window.opener !== window) {
      this.loading = false;
      return;
    }
    this.handleCallback();
  },
  methods: {
    async handleCallback() {
      const msalInstance = msalService.instance;

      try {
        const response = await msalInstance.handleRedirectPromise();

        if (response) {
          const idToken = response.idToken;
          msalInstance.setActiveAccount(response.account);

          // You can optionally call an API to validate the token here,
          // or dispatch a Vuex action if you're using it globally.
          await this.$store.dispatch("authentication/microsoftLogin", idToken);
          await this.$router.push("/");
        } else {
          // No response, maybe coming from another IdP (like SafeNet)
          const urlParams = new URLSearchParams(window.location.search);
          const code = urlParams.get("code");
          const state = urlParams.get("state");
          const session_state = urlParams.get("session_state");

          if (!code || !state) {
            this.error = "Missing code or state";
            this.loading = false;
            this.$router.push(`/login?error=${encodeURIComponent(this.error)}`);
            return;
          }

          // Forward SafeNet params to login for backend token exchange
          this.$router.push({
            path: "/login",
            query: {
              code,
              state,
              session_state: session_state || "",
            },
          });
        }
      } catch (err) {
        console.error("Callback handling error:", err);
        this.error = err.message || "Unknown error during callback";
        this.loading = false;
      } finally {
        localStorage.removeItem("safenet_state");
      }
    },
  },
};
</script>
